import { StyleSheet, Text } from '@react-pdf/renderer'
import React from 'react'
import { ErrorBoundary } from '../../error-boundary'

const styles = StyleSheet.create({
	lineThrough: {
		fontFamily: 'Inter',
		textDecoration: 'line-through',
	},
})

const StrikeThrough = ({ children }: { children: React.ReactNode }) => {
	return (
		<ErrorBoundary message={'Error in StrikeThrough'}>
			<Text style={styles.lineThrough}>{children}</Text>
		</ErrorBoundary>
	)
}

export default StrikeThrough
